var _style, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "information_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".information_svg__st11{fill:#e30613}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M928.2 235.6c.6 1 1.3 1.9 1.9 2.9-.6-1-1.3-2-1.9-2.9zM873.4 270.7c.9 1.6 1.9 3.2 3.1 4.6-.8-1.3-1.6-2.5-2.5-3.8-.2-.3-.4-.6-.6-.8zM782.9 92.3c1.9 1.2 3.7 2.4 5.6 3.7-1.7-1.5-3.6-2.7-5.6-3.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M512 77.4c58.7 0 115.6 11.5 169.1 34.1 51.7 21.9 98.2 53.2 138.1 93.2 39.9 39.9 71.3 86.4 93.2 138.1 22.6 53.5 34.1 110.4 34.1 169.1S935 627.5 912.4 681c-21.9 51.7-53.2 98.2-93.2 138.1-39.9 39.9-86.4 71.3-138.1 93.2-53.5 22.6-110.4 34.1-169.1 34.1-58.7 0-115.6-11.5-169.1-34.1-51.7-21.9-98.2-53.2-138.1-93.2-39.9-39.9-71.3-86.4-93.2-138.1-22.7-53.4-34.2-110.3-34.2-169s11.5-115.6 34.1-169.1c21.9-51.7 53.2-98.2 93.2-138.1 39.9-39.9 86.4-71.3 138.1-93.2C396.4 88.9 453.3 77.4 512 77.4m0-65C236.1 12.4 12.4 236.1 12.4 512c0 275.9 223.7 499.5 499.6 499.5 275.9 0 499.6-223.7 499.6-499.5-.1-275.9-223.7-499.6-499.6-499.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9af17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M512 738V389.7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.1,
    cy: 279.7,
    r: 32.6,
    fill: "#f9af17"
  }))));
}

export default SvgInformation;